import { FocusStyleManager } from "@blueprintjs/core";

export function setFocusStyleDefault() {
  // Disable focus outline, recommended by Blueprint
  FocusStyleManager.onlyShowFocusOnTabs();
}

// Disable all @hello-pangea/dnd development warnings
(window as any)["__@hello-pangea/dnd-disable-dev-warnings"] = true;
